"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require("angular");

var _angular2 = _interopRequireDefault(_angular);

var _noHTML = require("./noHTML.filter");

var _noHTML2 = _interopRequireDefault(_noHTML);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noHTMLmodule = _angular2.default.module('noHTML.filter', []).filter('noHTML', _noHTML2.default).name;

exports.default = noHTMLmodule;


// WEBPACK FOOTER //
// ./client/app/common/filters/noHTML/noHTML.js